import i18next, { init, use, type BackendModule } from "i18next";
import resourcesToBackend from "i18next-resources-to-backend";
import { initReactI18next } from "react-i18next";

import { locales, WaterlyLocale } from "@waterly/locales";

const backendModule: BackendModule = resourcesToBackend(async (language: string, namespace: string) => {
  return locales[language as WaterlyLocale]?.[namespace];
});

use(initReactI18next).use(backendModule);

const postProcess = [];
if (localStorage.getItem("test-LANG")) {
  use({
    type: "postProcessor",
    name: "testLang",
    process: () => "~~~~",
  });
  postProcess.push("testLang");
}

const locale = localStorage.getItem("locale") ?? WaterlyLocale.enUS;

void init({
  postProcess,
  lng: locale,
  load: "currentOnly",
  fallbackLng: WaterlyLocale.enUS,
  defaultNS: ["glossary", "common"],
  ns: [
    "AddressPurposeEnum",
    "DataEntryCompletionEmailOptionEnum",
    "DataGridColumnHeaders",
    "EventTypeEnum",
    "EventTypeGroupEnum",
    "RecurrenceTypeEnum",
    "SiteTypeEnum",
    "SystemTypeEnum",
    "TagTypeEnum",
    "WaterlyLocals",
    "address",
    "admin",
    "common",
    "errors",
    "glossary",
    "labImport",
    "months",
    "role",
    "yup",
  ],
  interpolation: {
    escapeValue: false, // react already safe from xss
    format: (value: string, format) => {
      if (format === "lowercase") {
        return value.toLocaleLowerCase();
      }

      return value;
    },
  },
  react: {
    transSupportBasicHtmlNodes: true,
    transKeepBasicHtmlNodesFor: ["br", "strong", "i", "p", "em", "span"],
  },
  debug: process.env.NODE_ENV === "development",
});

export default i18next;
